// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"422eec9b","462":"d4de979b","693":"cb0b1419","983":"9dc3fb7a"}[chunkId] + ".chunk.js";
};